import type { LocationQuery, RouteParams } from 'vue-router';

type NormalizeActivityListRoutePayload = {
	currentHash: string;
	currentName: null | string | symbol | undefined;
	currentParams: RouteParams;
	currentQuery: LocationQuery;
	desiredDate: string;
	desiredModule: string;
	desiredSource: string;
	desiredView: string;
};

type NormalizedActivityListRoute = {
	hash: string;
	name: null | string | symbol | undefined;
	params: {
		date: string;
		source: string;
		view: string;
	};
	query: LocationQuery;
};

const hasCompleteActivityListParams = (
	params: RouteParams
): params is {
	date: string;
	source: string;
	view: string;
} & RouteParams => {
	return typeof params.date === 'string' && typeof params.source === 'string' && typeof params.view === 'string';
};

export const createNormalizedActivityListRoute = (
	payload: NormalizeActivityListRoutePayload
): NormalizedActivityListRoute | null => {
	if (payload.desiredModule === '') {
		return null;
	}

	const needsReplace =
		(hasCompleteActivityListParams(payload.currentParams) &&
			(payload.currentParams.date !== payload.desiredDate ||
				payload.currentParams.source !== payload.desiredSource ||
				payload.currentParams.view !== payload.desiredView)) ||
		payload.currentName !== payload.desiredModule;

	if (!needsReplace) {
		return null;
	}

	return {
		hash: payload.currentHash,
		name: payload.currentName,
		params: {
			date: payload.desiredDate,
			source: payload.desiredSource,
			view: payload.desiredView,
		},
		query: payload.currentQuery,
	};
};
